<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
    setup(){
        const store = useStore();
        const data = computed(() => store.getters.papers);

        // 確定圖片有沒有網址
        const check_url = (url) =>{
             if (url.length <= 0){
                return false;
            }
            else{
                return true;
            }
        };

        return { data, check_url };
    }
}
</script>

<template>
    <div class="container">
        <table class="table">
            <thead>
                <tr>
                    <th>年度</th>
                    <th>篇名</th>
                    <th>期刊等級</th>
                    <th>期刊名稱</th>
                    <th>第一作者</th>
                    <th>共同作者</th>
                    <th>卷期</th>
                    <th>起始頁</th>
                    <th>結束頁</th>
                    <th>總頁數</th>
                    <th>相關網址</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data" :key="item.id">
                    <td>{{ item.year }}</td>
                    <td>{{ item.title }}</td>
                    <td>{{ item.grade }}</td>
                    <td>{{ item.journal }}</td>
                    <td>{{ item.first }}</td>
                    <td>{{ item.common }}</td>
                    <td>{{ item.volume }}</td>
                    <td>{{ item.start }}</td>
                    <td>{{ item.end }}</td>
                    <td>{{ item.total }}</td>
                    <td v-if="check_url(item.url) === true"><a :href="item.url" target="_blank"><img src="../assets/img/relatelink.png" alt=""></a></td>
                    <td v-if="check_url(item.url) === false">{{ item.url }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<style scoped>

</style>